import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as ClearIcon} from 'assets/svg/cross.svg';
import {searchChanged} from 'models/tracing/grid/table';

import {CancelIcon, StyledInput} from './styled';

export const TableSearch = () => {
    const {t} = useTranslation();
    const [isFirstRender, setIsFirstRenter] = useState(true);
    const [value, setValue] = useState('');
    const delay = 1000;
    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRenter(false);
            return;
        }
        const timeoutId = setTimeout(() => {
            searchChanged(value);
        }, delay);
        return () => clearTimeout(timeoutId);
    }, [value, delay]);

    return (
        <StyledInput
            value={value}
            onChange={handleValueChange}
            placeholder={t('pages.tracing.search')}
            style={{minWidth: 350}}
            adornment={
                <CancelIcon
                    width={10}
                    height={10}
                    source={ClearIcon}
                    onClick={() => setValue('')}
                />
            }
        />
    );
};
